var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenedMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "opened-mail_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 22l10 6.74m0 0v26.48c0 2.09-1.69 3.78-3.78 3.78H4.78C2.69 59 1 57.31 1 55.22V28.74m58 0L43.87 38.83M1 28.74L11 22M1 28.74l15.13 10.09M8 52l13-11h18l13 11m-3-16.59V1H11v34.41M19 9h5m0 6h17m-22 8h22m-22 8h22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjAgNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDkgMjJMNTkgMjguNzRNNTkgMjguNzRWNTUuMjJDNTkgNTcuMzEgNTcuMzEgNTkgNTUuMjIgNTlINC43OEMyLjY5IDU5IDEgNTcuMzEgMSA1NS4yMlYyOC43NE01OSAyOC43NEw0My44NyAzOC44M00xIDI4Ljc0TDExIDIyTTEgMjguNzRMMTYuMTMgMzguODNNOCA1MkwyMSA0MUgzOUw1MiA1Mk00OSAzNS40MVYxSDExVjM1LjQxTTE5IDlIMjRNMjQgMTVINDFNMTkgMjNINDFNMTkgMzFINDEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgOpenedMail as ReactComponent };